<template>
	<div class="tabbar">
		<div class="tabbar-logo">
			<img class="tabbar-logo-img" src="../../assets/logo-tabbar.png" alt="">
		</div>
		<div class="tabbar-content">
			<div class="tabbar-content-left">
				<div class="tabbar-content-left-nav">
					<span @click="toNav('/about')">关于我们</span>
					<span @click="toNav('/enterprise')">企业文化</span>
					<span @click="toNav('/store')">商家入驻</span>
					<span @click="toNav('/recruit')">人才招聘</span>
					<span @click="toNav('/user')">用户体验</span>
				</div>
				<div class="tabbar-content-left-company">
					<div class="tabbar-content-left-company-detail">
						<span v-if="false">西安雁塔区二环南路西段118号安馨园大厦11D</span>
					</div>
					<div class="tabbar-content-left-company-detail">
						<span>技术支持：时购圈科技有限公司 <span v-if="false">媒体支持：陕西网渭南站</span></span>
					</div>
					<div class="tabbar-content-left-company-detail">
						<span>投稿信箱:youpop2046@qq.com</span>
					</div>
					<div class="tabbar-content-left-company-detail">
						<!-- 服务热线：400-699-1399 -->
						<span><span class="tabbar-click" @click="goICP">ICP备案：陕ICP备20005896号</span></span>
					</div>
					<div class="tabbar-content-left-company-contact">
						<img class="tabbar-content-left-company-icon" src="../../assets/wechat.png" alt="">
						<span>shigouquan</span>
						<img class="tabbar-content-left-company-icon" src="../../assets/mail.png" alt="">
						<span>shigouquan@yeah.net</span>
					</div>
					<div class="tabbar-content-left-company-detail">
						<span>
							请仔细阅读
							<span class="tabbar-privacy" @click="toNav('/privacy')">《时购圈隐私政策》</span>
							和
							<span class="tabbar-privacy" @click="toNav('/service')">《时购圈用户服务协议》</span>
							以了解您的权益及平台规则
						</span>
					</div>
				</div>
			</div>
			<div class="tabbar-content-right">
				<div class="tabbar-content-right-code">
					<img src="../../assets/logo-3.png" alt="">
				</div>
				<div class="tabbar-content-right-code">
					<img src="../../assets/applet.jpg" alt="">
				</div>
			</div>
		</div>
		<div class="tabbar-phone">
			<div class="tabbar-phone-top">
				<div class="tabbar-phone-top-left">
					<div class="tabbar-phone-logo">
						<img class="tabbar-phone-logo-img" src="../../assets/logo-tabbar.png" alt="">
					</div>
					<div class="tabbar-phone-contact">
						<div class="tabbar-phone-contact-block">
							<img class="tabbar-phone-content-icon" src="../../assets/wechat.png" alt="">
							<span>shigouquan</span>
						</div>
						<div class="tabbar-phone-contact-block">
							<img class="tabbar-phone-content-icon" src="../../assets/mail.png" alt="">
							<span>shigouquan@yeah.net</span>
						</div>
					</div>
				</div>
				<div class="tabbar-phone-top-right">
					<div class="tabbar-phone-content-right-code">
						<img src="../../assets/logo-3.png" class="tabbar-phone-content-right-img" alt="">
					</div>
					<div class="tabbar-phone-content-right-code">
						<img src="../../assets/applet.jpg" class="tabbar-phone-content-right-img" alt="">
					</div>
				</div>
			</div>
			<div class="tabbar-phone-bottom">
				<div class="tabbar-phone-content-left-company-detail">
					<span>西安雁塔区二环南路西段118号安馨园大厦11D</span>
				</div>
				<div class="tabbar-phone-content-left-company-detail">
					<span>技术支持：时购圈科技有限公司 媒体支持：陕西网渭南站</span>
				</div>
				<div class="tabbar-phone-content-left-company-detail">
					<span>投稿信箱:youpop2046@qq.com</span>
				</div>
				<div class="tabbar-phone-content-left-company-detail">
					<span>服务热线：400-699-1399 <span class="tabbar-click" @click="goICP">ICP备案：陕ICP备20005896号</span></span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'tabbar',
		props: {},
		data() {
			return {};
		},
		methods: {
			toNav(url) {
				window.location.href = '#app'
				this.$router.push(url)
			},
			goICP(){
				window.location.href = 'https://beian.miit.gov.cn/#/Integrated/recordQuery'
			}
		}
	}
</script>

<style>
	.tabbar {
		width: 100%;
		height: 400px;
		background-color: #f7f7f7;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
		padding: 0 15%;
		box-sizing: border-box;
	}

	.tabbar-logo {
		width: 30%;
		height: 100%;
		padding: 0 2%;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		align-content: center;
	}

	.tabbar-logo-img {
		width: 100%;
	}

	.tabbar-content {
		width: 70%;
		height: 100%;
		padding: 7% 2%;
		box-sizing: border-box;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
	}

	.tabbar-content-left {
		width: 60%;
		height: 100%;
		padding: 0 2%;
		box-sizing: border-box;
	}

	.tabbar-content-left-nav {
		width: 100%;
		height: 20%;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		align-items: flex-end;
		justify-content: flex-end;
	}

	.tabbar-content-left-nav span {
		margin-left: 5px;
		color: #808080;
		font-size: 18px;
		font-weight: 600;
		cursor: pointer;
	}

	.tabbar-content-left-company {
		width: 100%;
		height: 80%;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: flex-end;
		justify-content: center;
		align-items: flex-end;
	}

	.tabbar-content-left-company-detail {
		margin-bottom: 3px;
	}

	.tabbar-content-left-company-detail span {
		font-size: 12px;
		color: #808080;
	}

	.tabbar-content-left-company-contact {
		display: flex;
		flex-wrap: nowrap;
		align-content: center;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}

	.tabbar-content-left-company-icon {
		width: 30px;
		margin-left: 15px;
	}

	.tabbar-content-left-company-contact span {
		margin-left: 15px;
		font-size: 12px;
		color: #808080;
	}

	.tabbar-content-right {
		width: 40%;
		height: 100%;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;
	}

	.tabbar-content-right-code {
		width: 190px;
		box-sizing: border-box;
		border-radius: 10px;
		margin-right: 15px;
	}

	.tabbar-content-right-code img {
		width: 100%;
		border-radius: 15px;
	}

	.tabbar-privacy {
		color: cornflowerblue !important;
		cursor: pointer;
	}

	.tabbar-phone {
		display: none;
	}
	
	.tabbar-click{
		cursor: pointer;
	}
	
	.tabbar-click:hover{
		color: #00A1DE;
	}

	@media screen and (max-width: 768px) {
		.tabbar {
			height: auto;
			display: flex;
			flex-direction: column;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: center;
			padding: 0 5%;
			margin-top: 30px;
		}

		.tabbar-logo {
			display: none;
		}

		.tabbar-content {
			display: none;
		}

		.tabbar-phone {
			width: 100%;
			height: 300px;
			display: flex;
			flex-direction: column;
			flex-wrap: nowrap;
		}

		.tabbar-phone-top {
			width: 100%;
			height: 50%;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
		}

		.tabbar-phone-top-left {
			width: 40%;
			display: flex;
			flex-direction: column;
			flex-wrap: nowrap;
			justify-content: center;
			padding: 0 5px;
			box-sizing: border-box;
		}

		.tabbar-phone-logo {
			width: 100%;
		}

		.tabbar-phone-logo-img {
			width: 100%;
		}

		.tabbar-phone-contact {
			width: 100%;
			display: flex;
			flex-direction: column;
			flex-wrap: nowrap;
			align-content: center;
			justify-content: center;
			align-items: flex-start;
		}

		.tabbar-phone-contact-block {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			flex-direction: row;
			flex-wrap: nowrap;
			font-size: 10px;
			margin: 1px 0;
			color: #A6A6A6;
		}

		.tabbar-phone-content-icon {
			width: 20px;
			height: 16px;
			margin-right: 5px;
		}

		.tabbar-phone-top-right {
			width: 60%;
			height: 150px;
			display: flex;
			align-items: center;
		}

		.tabbar-phone-content-right-code {
			width: 50%;
		}

		.tabbar-phone-content-right-img {
			width: 100%;
		}

		.tabbar-phone-bottom {
			width: 100%;
			height: 50%;
			display: flex;
			flex-direction: column;
			flex-wrap: nowrap;
			align-items: flex-start;
			    justify-content: center;
		}

		.tabbar-phone-content-left-company-detail {
			color: #A6A6A6;
			font-size: 12px;
			margin: 8px 0;
		}
	}
</style>